<template>
    <div component="ContainerDoc">
        <header>
            <h1>Conatner Docs</h1>
        </header>
        <container
            name="demo"
            type="horizontal"
            state="edit"
            align="space"
            valign="stretch"
            block-width=""
            block-padding="large"
            block-height=""
            padding="large"
            margin=""
            wrap=""
        >
            <div block="demo">div block</div>
            <div block="demo">div block</div>
            <div block="demo">div block</div>
            <div block="demo">div block</div>
            <div block="demo">div block</div>
            <div block="demo">div block</div>
            <div block="demo">div block</div>
            <div block="demo">div block</div>
            <div block="demo">div block</div>
            <div block="demo">div block</div>
            <div block="demo">div block</div>
        </container>
    </div>
</template>
<script>
import Container from '@/mock/Container.vue';

export default {
    name: 'ContainerDoc',

    computed: {},

    data() {
        return {};
    },

    methods: {},

    components: {
        Container,
    },
};
</script>
<style lang="less">
@import '~@variables';

[component='ContainerDoc'] {
    header {
        margin-bottom: 80px;
    }

    [container='demo'] {
        min-height: 600px;

        [block='demo'] {
            transition: 0.5s;
        }
    }
}
</style>
